import type { Resource } from '../../';
export const country_countries_RO: Resource = {"default":"Romania"};
